<template>
  <div class="ClientContent">
    <div class="row1">
      <router-link :to="{ path: '/client/create' }"
        ><button class="btn">Ajouter Un nouveau client</button>
      </router-link>
    </div>
    <div class="row1"><div class="title">Clients</div></div>
    <b-row class="responsiveBlock">
      <b-col cols="3" class="responsiveWidht">
        <b-form-select
          v-model="per_page"
          :options="options"
          class="mb-3 responsiveWidht"
          value-field="item"
          text-field="name"
          disabled-field="notEnabled"
        ></b-form-select>
      </b-col>
      <b-col cols="5" class="responsiveWidht">
        <b-form-select
          v-model="selected1"
          :options="options1"
          class="mb-3"
          value-field="item"
          text-field="name"
          disabled-field="notEnabled"
        ></b-form-select>
      </b-col>
      <b-col cols="4" class="responsiveWidht">
        <div class="container_search" >
          <span class="icon"
            ><fa-icon :icon="{ prefix: 'fas', iconName: 'search' }"/></span
          ><input
            @change="filter"
            @input="filter"
            type="text"
            placeholder="Recherche"
            class="input"
            v-model="search"
          />
        </div>
      </b-col>
    </b-row>
    <div class="content-tab-users">
      <b-table
        responsive
        show-empty
        striped
        id="my-table"
        class="table"
        :items="getClients"
        :fields="fields"
        :current-page="page"
        :per-page="per_page"
        sort-icon-left
        no-sort-reset
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        empty-text="Il n'y a aucun enregistrement à afficher"
      >
        <template v-slot:cell(id)="data">
          <p class="font-p">{{ data.item.id }}</p>
        </template>
        <template v-slot:cell(first_name)="data">
          <div class="font-div">
            {{ data.item.first_name }}
          </div>
        </template>
        <template v-slot:cell(last_name)="data">
          <div class="font-div">
            {{ data.item.last_name }}
          </div>
        </template>
        <template v-slot:cell(email)="data">
          <p class="font-p">{{ data.item.email }}</p>
        </template>
        <template v-slot:cell(ref)="data">
          <p class="font-p">{{ data.item.ref }}</p>
        </template>
        <template v-slot:cell(actions)="data">
          <div class="actions">
            <div class="btnshow">
              <router-link :to="{ name: 'editClient', params: { id: data.item.id } }">
              <button
                class="btn"
                type="button"
              >
                Afficher / Modifier
              </button>
              </router-link>
            </div>
            <div class="btnDelete">
              <button
                class="btn delete"
                type="button"
                @click.prevent="handleClickDelete(data.item)"
              >
                <fa-icon :icon="{ prefix: 'fas', iconName: 'trash' }" />
              </button>
            </div>
          </div>
        </template>
      </b-table>
      <div class="pagination">
        <b-pagination
          
          v-model="page"
          :total-rows="clientsCount"
          :per-page="per_page"
          align="right"
          size="sm"
          prev-text="Precedent"
          next-text="Suivant"
          aria-controls="my-table"
          @change="pagination"
        ></b-pagination>
      </div>
      <div :class="modelContent">
        <!-- Delete User Modal -->
        <b-modal 
          modal-class="userDeleteModal"
          ref="userDeleteModal"
          id="userDeleteModal"
          no-close-on-backdrop
          title="Supprimer un Client "
          :hide-footer="true"
          hide-header-close
          no-close-on-esc
        >
          <p>
            Êtes-vous certain de vouloir supprimer le cient
            <strong class="name">
              {{ clientToDelete ? clientToDelete.first_name : "" }}
              {{ clientToDelete ? clientToDelete.last_name : "" }}</strong
            >
            ?
          </p>
          <div class="form-actions">
            <b-button @click="handleModalAnuuler" variant="outline-secondary"
              >Annuler</b-button
            >
            <b-button variant="success" @click="handleModalValideSupprimer"
              >Confirmer</b-button
            >
          </div>
        </b-modal>
        <!-- END Delete User Modal -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      fields: [
        { key: "id", label: "ID", sortable: true },
        { key: "last_name", label: "Prenom", sortable: true },
        { key: "first_name", label: "Nom", sortable: true },
        { key: "email", label: "Email", sortable: true },
        { key: "ref", label: "Référent", sortable: true },
        { key: "actions", label: "Actions", sortable: false },
      ],
      clientToDelete: null,
      page: 1,
      per_page: 2,
      sortBy: "id",
      sortDesc: false,
      search: null,
      modelContent: "",
      selected: 50,
      options: [
        { item: 2, name: "Afficher 2 clients" },
        { item: 50, name: "Afficher 50 clients" },
        { item: 100, name: "Afficher 100 clients" },
      ],
      selected1: null,
      options1: [
        { item: null, name: "Afficher tous les clients de la société" },
      ],
    };
  },
  methods: {
    ...mapActions(['getAllClient','removeClient']),
    handleClickUpdate(item) {
      console.log("item", item);
    },
    handleClickDelete(data_item) {
      this.modelContent = "modelContent";
      this.clientToDelete = data_item;
      this.$refs["userDeleteModal"].show();
    },
    handleModalAnuuler() {
      this.modelContent = "";
      this.$refs["userDeleteModal"].hide();
    },
    async handleModalValideSupprimer(){
      console.log('client supp',this.clientToDelete)
      if(await this.removeClient({ ...this.clientToDelete })){
        this.modelContent = "";
        this.$refs["userDeleteModal"].hide();
      }
    },
    filter() {
      return this.getClients.filter(
        (option) =>
          option["first_name"]
            .toLowerCase()
            .startsWith(this.search.toLowerCase()) ||
          option["last_name"]
            .toLowerCase()
            .startsWith(this.search.toLowerCase())
        //.includes(this.search.toLowerCase())
      );
    },
    pagination() {
      console.log("pagination");
    },
  },
  mounted(){
    this.getAllClient()
    this.options1[0].item=this.getAllClient.length
    this.selected1=this.getAllClient.length
    
  },
  computed: {
    ...mapGetters(['getClients']),
    clientsCount() {
      return this.getClients.length;
    },
  },
};
</script>
<style scoped  lang="scss">
// @import "node_modules/bootstrap/scss/bootstrap.scss";
// @import "node_modules/bootstrap-vue/src/index.scss";
.ClientContent {
  width: 100%;
  display: inline;
  padding: 5px;
  position: relative;
  margin: 15px;
  .row1 {
    width: 100%;
    .btn {
      //margin-top: 15px;
      background-color: #ff8c00;
      color: white;
      border: 1px solid #ff8c00;
      border-radius: 3px;
      font-size:13px;
      width: 180px;
      &:focus {
        outline: 0;
      }
      &:hover {
        border-color: #068596ba;
        background-color: #068596fa;
      }
    }
    .title {
      width: 100%;
      color: #068596ba;
      font-weight: bold;
      font-size: 20px;
      margin-top: 20px;
    }
    .Element {
      color: #8c9a9c;
      margin-top: 13px;
      margin-bottom: 13px;
    }
    .pagination {
      margin-top: 13px;
      margin-bottom: 13px;
      text-align: right;
    }
  }
  .container_search {
    width: 100%;
    display: flex;
    .icon {
      width: 16%;
      color: #b5bcbd;
      background-color: white;
      border: 1px solid #a6aeaf;
      border-radius: 5px 0px 0px 5px;
      padding: 5px;
      font-size: 15px;
      text-align: center;
      border-right: none;
    }
    .input {
      color: #b5bcbd;
      background-color: white;
      border: 1px solid #a6aeaf;
      padding: 8px;
      border-radius: 0px 5px 5px 0px;
      width: 84%;
      border-left: none;
      &:focus {
        outline: 0;
      }
      &::placeholder {
        color: #b5bcbd;
      }
    }
  }
  .content-tab-users {
    padding-top: 4px;
    .sortloading {
      padding-bottom: 20px;
    }
    table {
      width: 100%;
      text-align: center;
      margin-bottom: 1rem;
      color: #212529;
      border: 0;
      border : 1px solid #dfe1e2;
      margin-top: -8px;
      font-size: 12px;

      tbody {
        .font-div,
        .font-p {
          font-size: 15px;
          margin-top: 0;
          margin-bottom: 0;
          &.font-div {
            text-transform: capitalize;
          }
        }
        .actions {
          display: flex;
          text-align: center;
          .btnshow {
            width: 200px;
          }
          .btnDelete {
            width: 50px;
          }
          .btn {
            background-color: #068596fa;
            color: white;
            border: 0px;
            width: 80%;
            margin: 2px;
            font-size:13px;
            &:hover {
              background-color: #ff8c00;
            }
          }
          .delete {
            color: white;
            background-color: #a75252;
          }
        }
        .name {
          text-transform: capitalize;
        }
      }
    }
  }
}

@media screen and (max-width: 425px) {
.ClientContent{
   width: 100%;
   position: relative;
  .responsiveBlock{
    display: inline;
  }
  .responsiveWidht{
    max-width: 100%;
  }
  .content-tab-users {
      .pagination {
        display: inline-block;
        justify-content: space-between;
        justify-items: center;
        width: 100%;
        text-align: center;
      }
    }
} 
}
</style>
<style lang="scss">
.content-tab-users {
  .table.b-table.table-sm > thead > tr > [aria-sort].b-table-sort-icon-left,
  .table.b-table.table-sm > tfoot > tr > [aria-sort].b-table-sort-icon-left {
    background-position: left calc(3.3rem / 2) center;
    padding-left: calc(1.3rem + -0.35em);
  }
  .table {
    width: 100%;
    border-collapse: collapse;
    font-size:12px;
  }
  .table-striped tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.05);
  }
  .table.b-table > thead > tr > [aria-sort].b-table-sort-icon-left,
  .table.b-table > tfoot > tr > [aria-sort].b-table-sort-icon-left {
    background-position: right calc(0.75rem / 2) center;
    //padding-left: calc(0.75rem + 0.65em);
    min-width: 70px;
    outline: 0;
    border:1px solid #e9eaeb;
  }
  .table.b-table > thead > tr > [aria-sort="ascending"],
  .table.b-table > tfoot > tr > [aria-sort="ascending"] {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='black' d='M51 1l25 23 24 22H1l25-22z'/%3e%3cpath fill='black' opacity='.3' d='M51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e");
  }
  .table.b-table > thead > tr > [aria-sort="descending"],
  .table.b-table > tfoot > tr > [aria-sort="descending"] {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='black' opacity='.3' d='M51 1l25 23 24 22H1l25-22z'/%3e%3cpath fill='black' d='M51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e");
  }
  .table.b-table > thead > tr > [aria-sort],
  .table.b-table > tfoot > tr > [aria-sort] {
    cursor: pointer;
    background-repeat: no-repeat;
    background-size: 0.65em 1em;
  }
  .table.b-table > thead > tr > [aria-sort="none"],
  .table.b-table > tfoot > tr > [aria-sort="none"] {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='black' opacity='.3' d='M51 1l25 23 24 22H1l25-22zM51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e");
  }

  .table tbody td {
    border-bottom: 1px solid #dee2e6;
    padding: 5px;
    font-size:12px;
    border:1px solid #e9eaeb;
  }
  .table thead th {
    vertical-align: middle;
    background-color: white;
    color: #5f6263;
    border-bottom: 1px solid #dee2e6;
    border-top: 1px solid #dee2e6;
    div {
      width: 50%;
    }
    span {
      width: 50%;
    }
  }
  .table thead tr th {
    padding: 0px;
    padding-top: 10px;
    padding-bottom: 10px;
    outline: 0;
  }
  .table tbody td {
    color: #8c9a9c;
  }
  .table-sm th,
  .table-sm td {
    vertical-align: middle;
    border: 1px solid #dee2e6;
  }
  .pagination {
    display: flex;
    justify-content: space-between;
    justify-items: center;
    width: 100%;
    padding: 8px;
    color: #979292;
    ul {
      li {
        padding: 10px;
        button {
          border-radius: 5px;
          color: #979292;
          background-color: #e6e6e6;
          border: none;
          outline: 0;
          padding: 10px;
          &:focus {
            background-color: #c9c4c4;
          }
        }
      }
    }
  }
  .modelContent {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
  }
}
#userDeleteModal___BV_modal_outer_{
    position: absolute;
    top: 130px;
    left: 32%;
    width: 35%;
    outline: 0;
    .userDeleteModal {
      background-color:white;
      padding: 30px;
      outline: 0;
      border-radius: 5px;
      box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11);
      text-align: center;
      h5{
        font-size:22px;
      }  
      p{
        color:#9ba2a2;
      }
      .name {
        text-transform: capitalize;
        color:#686e6f;
      }
      .form-actions {
        padding-right: 15px;
        padding-top: 20px;
        button{
          margin-right: 15px;
        }
      }
    }
  }
  #userDeleteModal___BV_modal_content_{
    outline:0;
  }
@media screen and (max-width: 768px) {

#userDeleteModal___BV_modal_outer_{
    width: 340px;
     .userDeleteModal {
      padding:10px;
      }
}
}
@media screen and (max-width: 425px) {
.content-tab-users .pagination ul li{
    padding:3px;
    display: inline;
  }
#userDeleteModal___BV_modal_outer_{
    position: absolute;
    top: 130px;
    left: 80px;
    width: 270px;
    outline: 0;
    .userDeleteModal {
      padding:15px;
      .form-actions {
        padding-right: 5px;
        padding-top: 10px;
        button{
          margin-right: 5px;
        }
      }
    }
}
}
@media screen and (max-width: 375px) {

#userDeleteModal___BV_modal_outer_{
    left: 60px;
}
}
@media screen and (max-width: 320px) {

#userDeleteModal___BV_modal_outer_{
    left: 28px;
}
}
</style>
